import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../lib/cn'

const inputVariants = cva(
  'flex w-full text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/60! focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
  {
    variants: {
      variant: {
        // Bordered card field with focus ring.
        default: 'rounded-lg border border-input bg-card focus-visible:border-ring focus-visible:ring-offset-0',
        // No chrome — for inline values inside toolbars, cells, or labels.
        minimal: 'border-0 bg-transparent',
      },
      size: {
        default: 'h-9.5 px-3 py-2',
        sm: 'h-7 px-2 py-1',
      },
    },
    compoundVariants: [
      // Minimal ignores the height/padding presets so it sits inline with text.
      { variant: 'minimal', class: 'h-auto p-0' },
    ],
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export interface InputProps extends Omit<React.ComponentProps<'input'>, 'size'>, VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, variant, size, ...props }, ref) => (
  <input type={type} className={cn(inputVariants({ variant, size, className }))} ref={ref} {...props} />
))
Input.displayName = 'Input'

export { Input, inputVariants }
